import { Component, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { StickerData } from '../../services/sticker-list-controller/sticker-list-controller';
import { CommonModule } from '@angular/common';
import { CdkDragDrop, CdkDrag, CdkDropList } from '@angular/cdk/drag-drop';
import { StickerListControllerService } from '../../services/sticker-list-controller/sticker-list-controller.service';
import { MatIconModule } from '@angular/material/icon';
import { CanvasControllerService } from '../../../../../../services/canvas-controller/canvas-controller.service';

@Component({
  selector: 'livery-attach-sticker-list',
  imports: [CommonModule, MatIconModule, CdkDropList, CdkDrag],
  templateUrl: './livery-attach-sticker-list.component.html',
  styleUrl: './livery-attach-sticker-list.component.scss',
})
export class LiveryAttachStickerListComponent {
  public attachStickers: InputSignal<StickerData[]> = input<StickerData[]>([]);
  public editorStickerIndex: OutputEmitterRef<number> = output<number>();

  public selectedAttachedStickerIndex: number = -1;

  constructor(
    private canvasController: CanvasControllerService,
    private stickerListController: StickerListControllerService,
  ) {}

  //---------------------------------------------------------------------------------
  // Public methods
  //---------------------------------------------------------------------------------
  public drop(event: CdkDragDrop<StickerData[]>) {
    this.stickerListController.moveAttachSticker(event.previousIndex, event.currentIndex);
  }

  public onClickEditAttachSticker(index: number): void {
    this.editorStickerIndex.emit(index);
  }

  public onClickRemoveAtttachSticker(index: number): void {
    this.canvasController.removeSticker(this.stickerListController.stickerMeshes[index]);
    this.stickerListController.removeAttachSticker(index);
  }
}
